import clsx from "clsx";

// Helpers
import { getTypeDefinition } from "./inputUtils";

// MUI
import { Button, InputAdornment } from "@mui/material";

export default function StartAdornment(props) {
	const { type, clickable, disabled, error, hideButton, onSwitchType } = props;

	const typeDefinition = getTypeDefinition(type);

	return (
		<InputAdornment position="start">
			<Button
				title={clickable ? "Switch type" : ""}
				className={clsx({
					hidden: hideButton,
					"start-button": true,
					"clickable-button": !disabled && clickable,
					"disabled-button": disabled,
					"error-start-button": error,
					"disabled-clickable-button": disabled && clickable,
				})}
				disabled={disabled || !clickable}
				disableRipple={disabled || !clickable}
				sx={typeDefinition.styles}
				onClick={() => onSwitchType()}
			>
				{typeDefinition.symbol}
			</Button>
		</InputAdornment>
	);
}
